// extracted by mini-css-extract-plugin
export var growableInput = "_66-0";
export var tagContainer = "_66-2";
export var textInput = "_66-1";